module.exports = __webpack_public_path__ + "static/media/ui-image.aba71f5d.png";